import React from 'react'
import InnerHtml from '@peracto/peracto-editor-ui/dist/InnerHtml'

const ImageCard = ({
    card: { image, imageAlt, title, copy, linkText, linkUrl, openInNewTab },
    inStorefront,
}) => (
    <div
        data-testid="image-card"
        className="bg-brand-grey-90 rounded shadow overflow-hidden w-full h-full"
    >
        {image && (
            <div className="p-2">
                <img src={image} alt={imageAlt || ''} className="w-full object-cover" />
            </div>
        )}

        <div className="p-6 text-center">
            {title && <h3 className="text-2xl font-bold mb-2">{title}</h3>}

            {copy && (
                <div className="text-gray-600 mb-4">
                    <InnerHtml content={copy} />
                </div>
            )}

            {linkText && linkUrl && (
                <a
                    href={linkUrl}
                    target={openInNewTab ? '_blank' : '_self'}
                    rel={openInNewTab ? 'nofollow noreferrer' : ''}
                    className="font-semibold text-brand-primary"
                    onClick={e => {
                        if (!inStorefront) {
                            e.preventDefault()
                        }
                    }}
                >
                    {linkText}
                </a>
            )}
        </div>
    </div>
)

const ImageCardsBlockRenderer = ({ state: { cards = [] } }) => {
    const inStorefront = !window?.location?.pathname.includes('/content/edit/')

    const visibleCards = cards.filter(
        card => card.image || card.title || card.copy || card.linkText
    )

    if (!visibleCards.length && inStorefront) {
        return null
    }

    return (
        <div
            data-testid="image-cards-block"
            className="grid justify-center gap-6"
            style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 20rem), 20rem))' }}
        >
            {cards.map((card, index) => (
                <ImageCard key={index} card={card} inStorefront={inStorefront} />
            ))}
        </div>
    )
}

export default ImageCardsBlockRenderer
